module.exports = __webpack_public_path__ + "img/preview4.624230db.png";